export enum ResetPasswordDialogState {
  sendEmail = 'send-email',
  waitForEmail = 'wait-for-email',
  NewPassword = 'new-password',
}
